<div class="ir-mask-menuroll th-menuselect">
  <div class="ir-row">
    <div *ngIf="search" class="centered-modal" style="max-height: 500px; overflow-y: auto">
      <div class="ir-btn ir-btn--big th-btn-menusearch">
        <input
          autofocus
          focus="showSearch"
          class="ir-form-set"
          type="search"
          name="Search"
          placeholder="{{ 'common.placeholders.search' | translate }}"
          [(ngModel)]="query"
        />
      </div>
      <div *ngIf="none" class="ir-btn ir-btn--big menu-button th-btn-menuroll" (click)="selectMenu(null)">
        <span>{{ 'common.select.none' | translate }}</span>
      </div>
      <div
        class="ir-btn ir-btn--big menu-button"
        *ngFor="let item of selectorValues | searchBy : query; let i = index"
        (click)="selectMenu(hasProperty(item, 'value') ? item.value : i)"
        [ngClass]="
          (hasProperty(item, 'value') ? item.value == selectedIndex : i == selectedIndex)
            ? 'th-btn-normal'
            : 'th-btn-menuroll'
        "
      >
        <span>{{ item.label ? item.label : item }}</span>
      </div>
    </div>
    <div *ngIf="!search" class="centered-modal" style="max-height: 500px; overflow-y: auto">
      <div *ngIf="none" class="ir-btn ir-btn--big menu-button th-btn-menuroll" (click)="selectMenu(null)">
        <span>{{ 'common.select.none' | translate }}</span>
      </div>
      <div
        class="ir-btn ir-btn--big menu-button"
        *ngFor="let item of selectorValues; let i = index"
        (click)="selectMenu(hasProperty(item, 'value') ? item.value : i)"
        [ngClass]="
          (hasProperty(item, 'value') ? item.value == selectedIndex : i == selectedIndex)
            ? 'th-btn-normal'
            : 'th-btn-menuroll'
        "
      >
        <ng-container *ngIf="!showAsIcons; else icons">
          <span>{{ item.label ? item.label : item }}</span>
        </ng-container>
        <ng-template #icons>
          <span> {{ item.label }} </span><i class="material-icons">{{ item.icon != null ? item.icon : item }}</i>
        </ng-template>
      </div>
    </div>
  </div>
</div>
